import React, { useState, useRef, useEffect } from 'react'
import './Carousel.css'
import { BOOKSHELF_PLUS_IDS, DIGITAL_VIP_IDS } from '../../subscriptionIds'
import checkMediaSubscription from '../../utils/checkMediaSub'
import { MediaCard } from '../media'
import { Box, Icon, Button } from '@deseretbook/react-ui'

const getItemsPerPage = (width) => {
  if (width >= 1215) return 5
  if (width >= 992) return 4
  if (width >= 768) return 3
  if (width >= 480) return 2
  return 1
}

export const useResponsiveItemsPerPage = () => {
  const [itemsPerPage, setItemsPerPage] = useState(getItemsPerPage(window.innerWidth))

  useEffect(() => {
    const handleResize = () => {
      setItemsPerPage(getItemsPerPage(window.innerWidth))
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return itemsPerPage
}

const Carousel = ({ items = [] }) => {
  const itemsPerPage = useResponsiveItemsPerPage()
  const [currentIndex, setCurrentIndex] = useState(0)
  const containerRef = useRef(null)

  const totalItems = items.length

  const handleNext = () => {
    const nextIndex = (currentIndex + itemsPerPage) % totalItems
    setCurrentIndex(nextIndex)
  }

  const handlePrev = () => {
    const prevIndex = (currentIndex - itemsPerPage + totalItems) % totalItems
    setCurrentIndex(prevIndex)
  }

  const scrollToIndex = () => {
    const container = containerRef.current
    if (!container) return

    const itemWidth = container.offsetWidth / itemsPerPage
    container.scrollTo({
      left: currentIndex * itemWidth,
      behavior: 'smooth',
    })
  }

  React.useEffect(() => {
    scrollToIndex()
    // eslint-disable-next-line
  }, [currentIndex])

  const showButtons = items && items.length > itemsPerPage
  return (
    <Box id="CarouselContainer">
      {showButtons && (
        <Button onClick={handlePrev} className="page-button page-button-left">
          <Icon className="page-button-icon" name="chevronLeft" />
        </Button>
      )}

      <div className="carousel-container" ref={containerRef}>
        <div className="carousel-track" style={{ width: `${(100 / itemsPerPage) * totalItems}%` }}>
          {items.map((mediaItem, idx) => {
            const { mediaData = {} } = mediaItem
            const variantType = mediaData && mediaData.ebook ? 'ebook' : 'audiobook'
            const sku = mediaData[variantType] && mediaData[variantType].sku
            const isPlus = checkMediaSubscription(mediaData[variantType], BOOKSHELF_PLUS_IDS)
            const isVip = checkMediaSubscription(mediaData[variantType], DIGITAL_VIP_IDS)

            return (
              <div key={idx} className="carousel-item" style={{ width: `${100 / totalItems}%` }}>
                <MediaCard
                  media={mediaData}
                  mediaType={variantType}
                  isPlus={isPlus}
                  isVip={isVip}
                  variantSku={sku}
                  isDiscover
                />
              </div>
            )
          })}
        </div>
      </div>

      {showButtons && (
        <Button className="page-button page-button-right" onClick={handleNext}>
          <Icon className="page-button-icon" name="chevronRight" />
        </Button>
      )}
    </Box>
  )
}

export default Carousel
